import { Route, Switch } from 'react-router-dom';

import Budget from './sections/budget';
import Compare from './sections/compare';
import Competitors from './sections/competitors';
import Events from './sections/events';
import Meetings from './sections/meetings';
import Overview from './sections/overview';
import RateChangeLogs from './sections/rate-change-logs';
import RateLevels from './sections/rate-levels';
import RmRecs from './sections/rm-recs';
import Rooms from './sections/rooms';
import Scheduler from './sections/scheduler';

const Routes = () => {
  return (
    <Switch>
      <Route path='/dashboard/budget' component={Budget} exact />
      <Route path='/dashboard/compare' component={Compare} exact />
      <Route path='/dashboard/competitors' component={Competitors} exact />
      <Route path='/dashboard/events' component={Events} exact />
      <Route path='/dashboard/meetings' component={Meetings} exact />
      <Route path='/dashboard/scheduler' component={Scheduler} exact />
      <Route path='/dashboard/overview' component={Overview} exact />
      <Route path='/dashboard/rate_changes' component={RateChangeLogs} exact />
      <Route path='/dashboard/rate_levels' component={RateLevels} exact />
      <Route path='/dashboard/rm_recs' component={RmRecs} exact />
      <Route path='/dashboard/rooms' component={Rooms} exact />
    </Switch>
  );
};

export default Routes;
